const SEPARATOR = '::';

export function buildAssigneeDragId(assigneeId: string, equipmentTypeId?: string) {
  return equipmentTypeId ? `${assigneeId}${SEPARATOR}${equipmentTypeId}` : assigneeId;
}

export function parseAssigneeDragId(dragId: string) {
  const [assigneeId, equipmentTypeId] = dragId.split(SEPARATOR);

  return { assigneeId, equipmentTypeId };
}
